module.exports = __webpack_public_path__ + "media/images/sp/articles/report_temp_01-29126a5c58b87320e567cbfa95a3ad1d.webp";